import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BudgetsPage.CheckPeriodFormPart', {
    headline: 'Budget check period',
    oneMonthPeriod: '1 month',
    threeMonthPeriod: 'Financial quarter',
    sixMonthsPeriod: 'Half of financial year',
    yearlyPeriod: 'Financial year',
    yearToDate: 'Year to date',
    yearWithSelectedStartMonth: 'Year with selected start month',
    yearToDateWithCustomFirstMonth: 'Year to date starting from the selected month',
    customPeriod: 'Custom period',
    customMonthPeriodFrom: 'from',
    customMonthPeriodTo: 'to',
    monthSelectPlaceholder: 'Select month',
    learnMore: 'Learn more',
});
